import { localize2 } from '../../../nls.js';

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
const Categories = Object.freeze({
    View: localize2(1638, 'View'),
    Help: localize2(1639, 'Help'),
    Test: localize2(1640, 'Test'),
    File: localize2(1641, 'File'),
    Preferences: localize2(1642, 'Preferences'),
    Developer: localize2(1643, "Developer"),
});

export { Categories };
